module.exports = __webpack_public_path__ + "static/media/LI.73730255.svg";